import { action } from 'typesafe-actions';
import { ILeaderboard } from '@kattana-io/common';

const entity = 'competition';

const SET_COMPETITION_WALLET = `${entity}/SET_COMPETITION_WALLET`;
const REFRESH_COMPETITION = `${entity}/REFRESH_COMPETITION`;
const SET_LEADERBOARD = `${entity}/SET_LEADERBOARD`;

const actionSetCompetitionWallet = (wallet?: string) =>
  action(SET_COMPETITION_WALLET, wallet);
const actionRefreshCompetition = () => action(REFRESH_COMPETITION);
const actionSetLeaderboard = (data: ILeaderboard[]) =>
  action(SET_LEADERBOARD, data);

export {
  SET_COMPETITION_WALLET,
  REFRESH_COMPETITION,
  SET_LEADERBOARD,
  actionSetCompetitionWallet,
  actionRefreshCompetition,
  actionSetLeaderboard,
};
